module.exports = {
    __esModule: true,
    default: function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.playControl)+'" data-hook="playback-control" data-is-playing="false"> <button class="'+(props.styles.playbackToggle)+' '+(props.styles.controlButton)+'" data-hook="playback-control" aria-label="'+(props.texts.label)+'" type="button" tabindex="0"/></div>';return out;
} 
  };


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/controls/play/templates/control.dot.js
// module id = 181
// module chunks = 0